import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

export const authCodeFlowConfigForB2D: AuthConfig = {
  issuer: environment.b2d.issuer,
  redirectUri: environment.b2d.redirectUri,
  clientId: environment.b2d.clientId,
  responseType: environment.b2d.responseType,
  scope: environment.b2d.scope,
  requireHttps: environment.b2d.requireHttps,
  oidc: true,
  showDebugInformation: environment.b2d.showDebugInformation,
};
